var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46822 6.39411C3.35181 4.74492 4.74832 3.46143 6.39821 3.46143H9.92995C10.7769 3.46143 11.5407 3.97173 11.8665 4.75512L13.3433 8.30696C13.7031 9.17218 13.4477 10.1715 12.7173 10.7571L11.7967 11.4951C11.3859 11.8245 11.2462 12.3924 11.4898 12.8593C12.7417 15.2585 14.5919 17.2947 16.8419 18.7692C17.3168 19.0803 17.9442 18.9565 18.2985 18.5128L19.2578 17.311C19.8421 16.5792 20.8394 16.3233 21.7028 16.6838L25.2473 18.1637C26.0292 18.4902 26.5383 19.2556 26.5383 20.1043V23.6537C26.5383 25.3071 25.2101 26.6485 23.5644 26.5315C13.0408 25.7828 4.21427 16.9634 3.46822 6.39411Z",
    fill: "#FF9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.115a0fec052a6d4e7c2a7d61ab3ce816.svg";
export { ForwardRef as ReactComponent };